// extracted by mini-css-extract-plugin
module.exports = {"swatch":"ColorsPage_swatch__2MUsU"};